import { Route, Routes, Outlet } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { DispositivosListWrapper } from './dispositivos-list/DispositivosList'
import { DispositivoDetalhe } from './detalhe/DispositivoDetalhe'

const DispositivosPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.dispositivos.descricao')}>
                {t('menu.dispositivos')}
              </PageTitle>
              <DispositivosListWrapper />
            </>
          }
        />
        <Route
          path=':id'
          element={
            <>
              <PageTitle description={t('pagina.dispositivos.detalhe.descricao')}>
                {t('menu.dispositivos')}
              </PageTitle>
              <DispositivoDetalhe />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default DispositivosPage
